module.exports = __webpack_public_path__ + "img/check-circle-purple.925523c8.svg";